export default {
  data () {
    return {
      prefix: 'drag-drawer'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/drag-drawer/mixin.js